import { IFlexPanel } from '@bimser/components';
import { createSyncAction } from '@bimser/core';
import { List } from 'immutable';
import * as ActionTypesMain from './actionTypes';

export default function closeFlexPanelListAction(args: Array<IFlexPanel>) {
	const payload: List<IFlexPanel> = List(args);

	const action = createSyncAction(ActionTypesMain.CLOSE_FLEX_PANEL_LIST, payload);

	return action;
}
